import React, { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { toast } from 'sonner';
import { useCurrencies } from '../context/CurrencyContext';
import { api, errMsg } from '../lib/api';
import { CountryCurrencyFields } from './CountryCurrencyFields';
import { Button } from './ui/button';

export const ShopCountrySettings = () => {
  const { config, reload } = useCurrencies();
  const [value, setValue] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (config) setValue({ country: config.country || '', defaultCurrency: config.defaultCurrency, permittedCurrencies: config.permitted, version: config.shopVersion }); }, [config]);
  const save = async event => {
    event.preventDefault(); setBusy(true);
    try { await api.put('/shop/country', value); await reload(); toast.success('Country and currency settings saved'); }
    catch (error) { toast.error(errMsg(error)); }
    finally { setBusy(false); }
  };
  return value && <form data-testid="shop-country-settings" onSubmit={save} className="my-7 space-y-4">
    <CountryCurrencyFields value={value} onChange={setValue} prefix="shop-country" />
    <Button data-testid="shop-country-save" type="submit" disabled={busy}><Save size={16} className="mr-2" />{busy ? 'Saving…' : 'Save country & currencies'}</Button>
  </form>;
};